import { HelpCircle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqs } from "@/data/landingData";

const FaqSection = () => (
  <section id="faq" className="py-16 sm:py-24 bg-card/30">
    <div className="container mx-auto px-5 sm:px-4">
      <div className="text-center mb-10 sm:mb-16">
        <div className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-6 rounded-2xl bg-primary/10 flex items-center justify-center">
          <HelpCircle className="w-6 h-6 sm:w-8 sm:h-8 text-primary" />
        </div>
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
          Perguntas <span className="text-gradient-green">Frequentes</span>
        </h2>
        <p className="text-base sm:text-xl text-muted-foreground max-w-2xl mx-auto">Tire suas dúvidas sobre o portal, testes e cursos.</p>
      </div>

      <div className="max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`} className="border-border/50 bg-card/30 rounded-xl mb-3 px-4 sm:px-6 border">
              <AccordionTrigger className="text-left text-sm sm:text-base font-semibold hover:no-underline hover:text-primary py-4 sm:py-5">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-5">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default FaqSection;
